/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import clientService from '../../services/ClientService';
import ClientTypes from '../types/ClientTypes';

//* get all department list items
function getAll(pageOption, sortData, keyword, departmentName) {
  return async (dispatch) => {
    dispatch({ type: ClientTypes.GET_CLIENT_LIST_REQUEST });
    try {
      const res = await clientService.getAll(pageOption, sortData, keyword, departmentName);
      dispatch({
        type: ClientTypes.GET_CLIENT_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ClientTypes.GET_CLIENT_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const updateQueryParams = (paginationModel, sortInfo, keyword, departmentName) => ({
  type: ClientTypes.UPDATE_CLIENT_QUERY_PARAMS,
  payload: { paginationModel, sortInfo, keyword, departmentName }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: ClientTypes.ADD_CLIENT_REQUEST });
    try {
      const res = await clientService.add(postData);
      dispatch({ type: ClientTypes.ADD_CLIENT_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().client.queryParams;
      setTimeout(() => dispatch(ClientAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: ClientTypes.ADD_CLIENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            console.log('🚀 ~ return ~ error.response.data.errors:', error.response.data.errors);
            // toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: ClientTypes.GET_CLIENT_ITEM_REQUEST });
    try {
      const res = await clientService.getItem(code);
      dispatch({
        type: ClientTypes.GET_CLIENT_ITEM_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ClientTypes.GET_CLIENT_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: ClientTypes.UPDATE_CLIENT_REQUEST });
    try {
      const res = await clientService.update(code, postData);
      dispatch({
        type: ClientTypes.UPDATE_CLIENT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword, department } = getState().client.queryParams;
      setTimeout(
        () => dispatch(ClientAction.getAll(paginationData, sortingData, keyword, department)),
        500
      );
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: ClientTypes.UPDATE_CLIENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: ClientTypes.DELETE_CLIENT_REQUEST });
    try {
      const res = await clientService.deleteItem(code);
      dispatch({
        type: ClientTypes.DELETE_CLIENT_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(ClientAction.getAll()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ClientTypes.DELETE_CLIENT_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getCompanyClient(code) {
  return async (dispatch) => {
    dispatch({ type: ClientTypes.GET_COMPANY_CLIENT_ITEM_REQUEST });
    try {
      const res = await clientService.getCompanyClient(code);
      dispatch({
        type: ClientTypes.GET_COMPANY_CLIENT_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ClientTypes.GET_COMPANY_CLIENT_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getActiveItem() {
  return async (dispatch) => {
    dispatch({ type: ClientTypes.GET_CLIENT_ACTIVE_REQUEST });
    try {
      const res = await clientService.getActiveItem();
      dispatch({
        type: ClientTypes.GET_CLIENT_ACTIVE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: ClientTypes.GET_CLIENT_ACTIVE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function importClients(formData, setSubmitting, setResult) {
  return async (dispatch, getState) => {
    dispatch({ type: ClientTypes.ADD_CLIENT_REQUEST });
    try {
      const res = await clientService.importClients(formData);
      dispatch({ type: ClientTypes.ADD_CLIENT_SUCCESS, payload: res.data });
      if (res.data) {
        const { created = 0, skipped = 0 } = res.data;
        const skipNote = skipped > 0 ? ` Skipped ${skipped}.` : '';
        if (created > 0) {
          toast.success(`Imported ${created} client(s).${skipNote}`);
        } else {
          toast.info(`No clients imported. Skipped ${skipped}.`);
        }
        if (setResult) {
          setResult(res.data);
        }
        if (created > 0) {
          const { paginationData, sortingData, keyword, department } =
            getState().client.queryParams;
          setTimeout(
            () => dispatch(ClientAction.getAll(paginationData, sortingData, keyword, department)),
            500
          );
        }
      }
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      if (error && error.response) {
        dispatch({ type: ClientTypes.ADD_CLIENT_ERROR, error: error.response });
        if (error.response.status === 422 && error.response.data && error.response.data.errors) {
          const firstError = Object.values(error.response.data.errors)[0];
          if (firstError) {
            toast.error(firstError);
          }
        }
      }
    }
  };
}

function downloadImportTemplate() {
  return async () => {
    try {
      const res = await clientService.downloadImportTemplate();
      const blob = new Blob([res.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'client-import-template.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error && error.response) {
        toast.error('Could not download the template.');
      }
    }
  };
}

const ClientAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getCompanyClient,
  getActiveItem,
  updateQueryParams,
  importClients,
  downloadImportTemplate
};

export default ClientAction;
